<div class="live-search-container">
  <div class="live-search-input">
    <input type="text" class="input input-text" [placeholder]="placeHolder" [(ngModel)]="searchTerm" (input)="onSearchChange()" [appMaxLength]="maxLength">
  </div>
  <div class="search-list-container" *ngIf="filterSearchResults.length">
    <div class="list-item" *ngFor="let item of filterSearchResults" (click)="selectItem(item)">
      <p>{{item}}</p>
    </div>
  </div>
</div>
